import React, { useState, useEffect } from "react";
import { Button, Paper } from "@mui/material";
import TopBar from "./TopBar";
import useInstructionsStyles from "../../instructionStyle/default/InstructionsStyles";
import { decryptData } from "../../../../crypto";
import { useLanguages } from "../../../../context/LanguagesContext";
import { toast } from "react-toastify";
import { fetchCurrentTimeApi } from "../../../../services/service";
import ROUTES_NAME from "../../../../constants/RoutesName";
import { useNavigate } from "react-router-dom";
import Popup from "./Popup";
import Loader from "../../../../components/Loader";
import socket from "../../../../socket/socket";

const InstructionContent = ({ toggleSidebar }) => {
  const classes = useInstructionsStyles();
  const [showPopup, setShowPopup] = useState(false);
  const [agree, setAgree] = useState(false);
  const [popupInstructions, setPopupInstructions] = useState("");
  const [examInstructions, setExamInstructions] = useState("");
  const navigate = useNavigate();
  const { languages, handleChange, selectedLanguage } = useLanguages();

  const handleNextClick = async () => {
    setShowPopup(true);
    // if (sessionStorage.getItem("loginByClient") === "true") {
    //   setShowPopup(true);
    // } else {
    //   const response = await fetchCurrentTimeApi();
    //   const formatedcurrentTime = new Date(response.data.currentTime);
    //   const startDateTime = new Date(sessionStorage.getItem("startDateTime"));
    //   if (startDateTime.getTime() <= formatedcurrentTime.getTime()) {
    //     setShowPopup(true);
    //   } else {
    //     toast.warning("You cannot start the exam before schedule.");
    //   }
    // }
  };

  const handlePopupNext = () => {
    if (agree) {
      navigate(ROUTES_NAME.TEST);
      sessionStorage.setItem("loginTime", new Date().getTime());
      sessionStorage.setItem("examStarted", true);
      sessionStorage.removeItem("candidateLoggedinToInstructionsPage");
      const examId = sessionStorage.getItem("examId");
      const userId = sessionStorage.getItem("userId");
      socket.emit("changeStatus", {
        examId,
        userId,
        status: "Giving",
      });
      toggleFullscreen();
    } else {
      toast.warning("Please confirm that you have read the instructions!");
    }
  };

  useEffect(() => {
    if (!showPopup) {
      setAgree(false);
    }
  }, [showPopup]);

  useEffect(() => {
    socket.connect();
    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (selectedLanguage === "english") {
      setExamInstructions(
        decryptData(sessionStorage.getItem("examInstructions"))
      );
      setPopupInstructions(
        "I Have Read And Understood The Instructions. All Computer Hardware Allotted To Me Are In Proper Working Condition. I Declare That No Prohibited Gadget Like Mobile Phone, Bluetooth Devices Etc., Or Any Prohibited Material Is With Me In The Examination Hall. I Agree That If Found Guilty Of Any Malpractice, I May Be Debarred From This Test And/Or Subjected To Disciplinary Action, Which May Include A Ban From Future Tests/Examinations."
      );
    }
    if (selectedLanguage === "hindi") {
      setExamInstructions(
        decryptData(sessionStorage.getItem("instructionsHindi"))
      );
      setPopupInstructions(
        "मैंने निर्देश पढ़े और समझे हैं। मुझे आवंटित सभी कंप्यूटर हार्डवेयर ठीक काम कर रहे हैं। मैं घोषित करता हूं कि परीक्षा हॉल में मेरे पास कोई प्रतिबंधित गैजेट जैसे मोबाइल फोन, ब्लूटूथ उपकरण आदि या कोई भी प्रतिबंधित सामग्री नहीं है। मैं सहमत हूं कि यदि किसी भी अनुचित प्रक्रिया का दोषी पाया जाता है, तो मुझे इस परीक्षण से वंचित किया जा सकता है और/या अनुशासनात्मक कार्रवाई के अधीन किया जा सकता है, जिसमें भविष्य के परीक्षणों/परीक्षाओं से प्रतिबंध शामिल हो सकता है।"
      );
    }
  }, [selectedLanguage]);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement
        .requestFullscreen()
        .catch((err) => alert("Please use F11 for fullscreen"));
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <div className={classes.instructionsRoot}>
      <TopBar
        toggleSidebar={toggleSidebar}
        languages={languages}
        selectedLanguage={selectedLanguage}
        handleChange={handleChange}
      />
      <Paper style={{ boxShadow: "none" }} className={classes.instructionsBody}>
        {examInstructions ? (
          <div className={classes.instructionContent}>
            <div
              className={classes.instructionsContainer}
              dangerouslySetInnerHTML={{ __html: examInstructions }}
              style={{
                fontSize: "1rem",
                lineHeight: "1.6",
                "@media (min-width: 800px) and (max-width: 898px)": {
                  fontSize: "0.7rem !important",
                },
              }}
            />

            <div style={{ padding: "20px" }}>
              <Button
                variant="contained"
                color="primary"
                className={classes.nextButton}
                onClick={handleNextClick}
                sx={{
                  "@media (min-width: 800px) and (max-width: 898px)": {
                    fontSize: "0.7rem",
                    padding: "6px 16px",
                    marginBottom: "20px",
                  },
                }}
              >
                Next
              </Button>
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </Paper>

      <Popup
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        popupInstructions={popupInstructions}
        setAgree={setAgree}
        agree={agree}
        handlePopupNext={handlePopupNext}
      />
    </div>
  );
};

export default InstructionContent;
